import { Component, EventEmitter, Output, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../_services/app.common.service';
import { SlideLeftRight } from '../../_animations/animations';

import { SecurityRoleItems, SecurityRoleMainMenu } from '../../_enums/securityRoleItems';
import { RoleAccessService } from '../../_services/role.access.service';
import { DesktopNotify, Notifiactions, UserInfo } from './_footer.interfaces';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    animations: [
        SlideLeftRight,
    ],
    standalone: false
})
export class FooterComponent implements OnInit {
  public topMenuIndex = 5;
  public showMoreMenu = false;
  public totalNotifications = 0;
  public notification = {} as  Notifiactions;
  public permission = {} as  DesktopNotify;
  public isNotificationLoaded = false;
  public loading = true;
  public userInfo = {} as UserInfo;
  @Output() closeMenu = new EventEmitter();
  @Output() onLoad: EventEmitter<any> = new EventEmitter();

  public slideDirection = '*';
  public isTalentPoolAllowed = false;
  public isSearchAllowed = false;
  public isCalenderAllowed = false;
  public isMyNewStartersAllowed = false;
  public isFeature_Onboarding = false;


  constructor(public common: CommonService, public roleService: RoleAccessService ) {
  }
  public openMoreMenu() {

    this.closeMenu.emit();
  }
  ngOnInit(): void {
 
    this.userInfo = this.common.GetLoggedinUserInfo();
    this.GetNotification();
      this.isTalentPoolAllowed = this.roleService.HasAccess(SecurityRoleItems.MyTalentPools);
      this.isSearchAllowed = this.roleService.HasMainMenuAccess(SecurityRoleMainMenu.Search);
      this.isCalenderAllowed = this.roleService.HasMainMenuAccess(SecurityRoleMainMenu.Calendar);
      this.isFeature_Onboarding = this.roleService.HasAccess(SecurityRoleItems.Feature_Onboarding);
    if (this.isFeature_Onboarding)
      this.isMyNewStartersAllowed = this.roleService.HasAccess(SecurityRoleItems.MyNewStarters);
    
  }

  public navigateTo(path: string) {

    if (path == 'Home') {
      this.common.NavigateToRouteWithQueryString('Home');
    } else if (path == 'MyJobs') {
      this.common.NavigateToRouteWithQueryString('MyJobs/List');
    }
    else if (path == 'Search') {
      this.common.NavigateToRouteWithQueryString('Search/Candidates');
    }
    else if (path == 'Reports') {
      this.common.NavigateToRouteWithQueryString('Home');
    }
    else if (path == 'User') {
      this.common.NavigateToRouteWithQueryString('Settings');
    }
    else if (path == 'SearchJC') {
      //this.common.navigateByUrl("/Search");
      this.common.NavigateToRouteWithQueryString('Search');
    }
  }


  public toggleMoreMenu() {

    if (this.showMoreMenu) {

      this.slideDirection = 'left'
      this.showMoreMenu = false;
    }
    else {
      this.showMoreMenu = true;
      this.slideDirection = 'right';
    }
  }

  public logout() {
    this.common.RedirectToLogin();
  }

  public GetNotification() {
    var totalno = this.common.GetFromLocalStorage("TotalNotifications");
    if (totalno) {
      this.totalNotifications = parseInt(totalno);
    }
    else {
      this.common.GetData(this.common.ApiUrls.Talents.GetNotification, true).then(data => {
        this.common.RemoveLocalStorage('TotalNotifications');
        var totalNotifications = 0;
        var data = data.resultData;
        this.notification = data
        this.permission = data.permission;
        if (this.notification) {
          this.isNotificationLoaded = true;
          if (this.permission != null) {
            if ((this.permission.isCandidates) == 'Yes') {
              totalNotifications += this.notification.nmStatuses;
            }
            if ((this.permission.isJobs) == 'Yes') {
              totalNotifications += this.notification.nmOfSMS;
            }
            if ((this.permission.isAuthoriseJob) == 'Yes' || (this.permission.isAuthoriseCandidate) == 'Yes') {
              totalNotifications += this.notification.nmOfAutho;
            }
          }
        }
        this.common.SetLocalStorage("TotalNotifications", totalNotifications);
        this.onLoad.emit(totalNotifications);
        this.loading = false;
        var totalno = this.common.GetFromLocalStorage("TotalNotifications");
        if (totalno) {
          this.totalNotifications = parseInt(totalno);
        }
      }, error => { console.log("erre", error); });
    }

  }
}




